// @ts-strict-ignore
import { CreateReductionGoalRequest } from '../../api/core/models/api/create-reduction-goal-request';
import { UpdateReductionGoalRequest } from '../../api/core/models/api/update-reduction-goal-request';
import { BoardReductionGoal } from '../../model/board-reduction-goal';
import { RetryConfig, timer } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

export function toReductionGoalRequest<T extends Omit<BoardReductionGoal, 'id'>>({
  goal,
  ratified,
  ratifiedDate,
  referenceYear,
  referenceYearEmissions,
}: T): T extends BoardReductionGoal ? UpdateReductionGoalRequest : CreateReductionGoalRequest {
  return {
    goal,
    ratified: !!ratified && !!ratifiedDate,
    ratifiedDate: !!ratified && !!ratifiedDate ? ratifiedDate?.toISOString() : null,
    referenceYear,
    referenceYearEmissions,
  };
}
